export enum ModuleTokens {
  Name = 'files'
}
